import { session } from '@/components/helpers/session'
import { ID } from '@omneo/omneo-sdk'
import { OmneoPortal } from './portal'

export class OmneoClient {
  id
  client
  portal

  static async fetchIdToken() {
    const customerId = GM_STATE?.customer?.id
    const customerSignature = GM_STATE?.customer?.signature

    if (!customerId || !customerSignature) return undefined

    const response = await fetch(
      `https://extension-shopify-v5r64nnrcq-ts.a.run.app/${GM_STATE.omneo.tenantId}/api/v1/auth/token`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: customerId,
          signature: customerSignature
        })
      }
    )

    const data = await response.json()
    const { token, exp: expiry } = data

    if (!token || !expiry) return undefined

    session.omneoAuthToken.set(token)
    session.omneoAuthExpiry.set(token)

    return {
      token,
      expiry
    }
  }

  static async init() {
    const customerId = GM_STATE?.customer?.id
    const isLoggedIn = GM_STATE?.customer?.logged

    const portal = new OmneoPortal(GM_STATE.omneo.tenantId)

    if (!isLoggedIn || !customerId) return new this(portal)

    const sessionToken = session.omneoAuthToken.get()
    const sessionExpiry = session.omneoAuthExpiry.get()
    if (sessionToken && sessionExpiry) {
      const id = new ID({
        tenant: GM_STATE.omneo.tenantId,
        IDToken: sessionToken,
        IDTokenExpiry: sessionExpiry
      })

      if (!id.auth.isTokenExpired()) {
        return new this(portal, id)
      }
    }

    const { token: fetchedToken, expiry: fetchedExpiry } = await OmneoClient.fetchIdToken()
    const id = new ID({
      tenant: GM_STATE.omneo.tenantId,
      IDToken: fetchedToken,
      IDTokenExpiry: fetchedExpiry
    })

    return new this(portal, id)
  }

  static async logout() {
    return new Promise((resolve) => {
      // Create invisible iframe
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = GM_STATE.omneo.apiBaseUrl ?? 'https://my.shoesandsox.com.au/'
      document.body.appendChild(iframe)

      // Wait for iframe to load before sending message
      iframe.onload = () => {
        window.addEventListener('message', (e) => {
          if (e.data === 'logout') {
            resolve()
          }
        })
        iframe.contentWindow.postMessage(
          {
            action: 'logout'
          },
          '*'
        )

        // Fallback to timeout if message is not received
        setTimeout(() => {
          resolve()
        }, 3000)
      }
    })
  }

  constructor(portal, id) {
    this.id = id ?? undefined
    this.portal = portal
  }
}
